export default __webpack_public_path__ + "static/media/A2.ce14525f.png";